import * as THREE from "three";

export type Vector2Like = THREE.Vector2 | { x?: unknown; y?: unknown } | null | undefined;

const finiteNumber = (value: unknown, fallback = 0): number => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : fallback;
};

export const toVector2 = (point: Vector2Like, fallback?: Vector2Like): THREE.Vector2 => {
  const fallbackX = fallback ? finiteNumber(fallback.x) : 0;
  const fallbackY = fallback ? finiteNumber(fallback.y) : 0;

  if (point instanceof THREE.Vector2) {
    return point.clone();
  }

  return new THREE.Vector2(
    finiteNumber(point?.x, fallbackX),
    finiteNumber(point?.y, fallbackY),
  );
};

export const toOptionalVector2 = (point: Vector2Like): THREE.Vector2 | undefined => {
  if (!point) {
    return undefined;
  }
  return toVector2(point);
};

export const toVector2Array = (points: unknown): THREE.Vector2[] => (
  Array.isArray(points) ? points.map((point) => toVector2(point as Vector2Like)) : []
);

export const serializeVector2 = (point: Vector2Like): { x: number; y: number } => ({
  x: finiteNumber(point?.x),
  y: finiteNumber(point?.y),
});
